module.exports = __webpack_public_path__ + "img/file-pdf-box.fe15a085.svg";